import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { localStorageMetaReducer } from './reducers/meta-reducers';
import { appReducers } from './reducers/app.reducer';
import { environment } from 'src/environments/environment';

@NgModule({
  imports: [
    StoreModule.forRoot(appReducers, {
      metaReducers: [localStorageMetaReducer],
    }),
    // StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: false }),
    ...(environment.enableDevTools
      ? [
          StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: false,
          }),
        ]
      : []),
  ],
})
export class AppStoreModule {}
